/* First-visit country/language popup: detect the visitor's country, pre-select it, show once. */
(function () {
  var KEY = 'pz-geo-confirmed';
  var el = document.getElementById('pz-geo');
  if (!el) return;

  // don't interrupt the theme editor
  if (window.Shopify && window.Shopify.designMode) return;

  var already;
  try { already = localStorage.getItem(KEY); } catch (e) {}
  if (already) return;

  function flag() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
  function show() { el.hidden = false; document.documentElement.classList.add('pz-geo-open'); }
  function hide() { el.hidden = true; document.documentElement.classList.remove('pz-geo-open'); }

  // pre-select the detected country, then reveal
  fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var det = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
      if (!det) return;
      var sel = document.getElementById('pz-geo-country');
      if (sel && sel.querySelector('option[value="' + det + '"]')) sel.value = det;
    })
    .catch(function () {})
    .then(show, show);

  // confirming (submitting) sets the market + reloads — remember the choice first
  var form = document.getElementById('pz-geo-form');
  if (form) form.addEventListener('submit', flag);

  // dismissing (X / clicking outside) keeps the current country but still counts as answered
  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-pz-geo-dismiss]')) { flag(); hide(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !el.hidden) { flag(); hide(); }
  });
})();
